import { useTranslation } from 'next-i18next';
import {
  Chip, LinkStyled,
  PopoverStyled, PopoverStyledButton, PopoverStyledPanel,
} from '@components/common';

const TopBarStandaloneLinks = () => {
  const { t } = useTranslation();

  const navigationLinks: { path: string, label: string }[] = [
    {
      path: '/applied-jobs',
      label: 'header.menu.applied_jobs',
    },
    {
      path: '/favorite-jobs',
      label: 'header.menu.favorite_jobs',
    },
    {
      path: '/cv-evaluations',
      label: 'cv.evaluations.page.title',
    },
  ];

  return (
    <PopoverStyled>
      {({ open }) => (
        <>
          <PopoverStyledButton
            as={Chip}
            isDropdownOpen={open}
            withDropdownArrow
          >
            {t('header.menu.applied_jobs')}
          </PopoverStyledButton>

          <PopoverStyledPanel
            className="scrollbar-thin mt-1 max-h-96 w-max min-w-44 overflow-y-auto !rounded-md py-2"
            animation="slideDown"
            anchor="bottom start"
          >
            {navigationLinks.map((navLink) => (
              <div
                key={`navlink_${navLink.label}`}
                className="hover:bg-surface-50 hover:text-ink"
              >
                <LinkStyled
                  href={navLink.path}
                  styling="none"
                  size="sm"
                  rounding="none"
                  className="flex cursor-pointer items-center gap-1 px-5 py-1.5 text-sm text-ink-medium hover:text-ink"
                >
                  {t(navLink.label) }
                </LinkStyled>
              </div>
            ))}
          </PopoverStyledPanel>
        </>
      )}
    </PopoverStyled>
  );
};

export default TopBarStandaloneLinks;
